<style lang="scss" scoped>
  @import '../../styles/vars/main';
  @import '../../styles/helpers/main';
  .uploader{
    display: flex;
    flex-direction: column;
    height: 100%;
    &__dropbox {
      outline: 1px dashed color("flamingo", "dark", 0.5); /* the dash box */
      outline-offset: -10px;
      background: color("flamingo");
      color: color("flamingo", "dark");
      padding: 30px 30px;
      min-height: 200px; /* minimum height */
      position: relative;
      cursor: pointer;
      border-radius: 8px;
      transition: all 0.2s ease;
      margin-bottom: space('comfortable');
    }
    &__headline {
      margin-bottom: space('comfortable');
    }
    &__input-file {
      opacity: 0; /* invisible but it's there! */
      width: calc( 100% - 30px);
      height: calc( 200px - 30px);
      position: absolute;
      cursor: pointer;
    }
    &__file-list{
      list-style-type: none;
      flex: 1;
      overflow-y: auto;
      margin-bottom: space("narrow");
    }
    &__file-list-item + &__file-list-item{
      margin-top: space('narrow');
    }

    &__dropbox:hover {
      background: color("flamingo", "dark");
      color: color("white");
    }
    &__thumbnail {
      display: flex;
      align-items: center;
    }
    &__thumbnail-img {
      align-self: center;
      width: 100px;
      height: auto;
      border-radius: 8px;
    }
    &__thumbnail-info {
      font-size: font-size("deci");
      color: color("grey", "darkest");
      margin-left: space("narrow");
      flex: 1;
    }
    &__thumbnail-remove {
      background-color: color("grey");
      color: color("grey", "darkest");
      svg {
        @include svg-dim("base");
      }
      &:hover{
        background-color: color("warning");
        color: color("white");
      }
    }

    &__progressbar {
      margin-top: space('skinny');
      width: 100%;
      background-color: lightgrey;
      height: 10px;
      border-radius: 10px;
      overflow:: hidden;
    }

    &__percent{
      background-color: color("nile");
      width: 0%;
      height: 10px;
      transition: all 0.2s ease;
      &.\--finished{
        background-color: color("success", "dark");
      }
    }

    &__footer {
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
    }
  }

</style>
<template>
  <div class="uploader">
  <!--UPLOAD-->
    <v-headline :level="'2'" cssClass="--nile uploader__headline">Upload images</v-headline>
    <form enctype="multipart/form-data" novalidate>
      <div class="uploader__dropbox">
        <input type="file" multiple  @change="filesChange" accept="image/*" class="uploader__input-file">
        Drag your file(s) here or click to browse
      </div>
    </form>
    <ul
      ref="uploadList"
      v-if="files.length != 0"
      class="uploader__file-list"
    >
      <li
        ref="uploadItem"
        class="uploader__file-list-item" v-for='(file, index) in files' :key='index'
      >
        <div class="uploader__thumbnail">
          <img class="uploader__thumbnail-img" :src="file.src" alt="">
          <p
            ref="thumbInfo"
            class="uploader__thumbnail-info"
          >
            {{file.filename}} - <span v-kb>{{file.size}}</span> kb
          </p>
          <v-button
            class="button-circle uploader__thumbnail-remove js-remove"
            @click.prevent="remove(index)">
            <svg>
              <use xlink:href="#delete"></use>
            </svg>
          </v-button>
        </div>
        <div class="uploader__progressbar">
          <div
            ref="uploadPercent"
            class="uploader__percent"
            :style="{ width: file.uploaded }"></div>
        </div>
      </li>
    </ul>
    <p
      class="u-flex-1"
      v-else
    >
      Select some Photos.
    </p>
    <div class="uploader__footer">
      <v-button cssClass="button --secondary" @click.prevent="resetFiles">Reset files</v-button>
      <v-button @click.prevent="saveFiles">Save</v-button>
    </div>
  </div>
</template>
<script>
import photosApi from '@/apis/photos-api';
import { mapGetters } from 'vuex';
import Button from '../button';
import Headline from '../headline';
export default {
  data() {
    return {
      files: []
    };
  },
  components: {
    'v-headline': Headline,
    'v-button': Button
  },
  computed: {
    ...mapGetters([
      'activeId'
    ])
  },
  directives: {
    kb: {
      bind (el, b, n, o) {
        const kb = Number(el.innerHTML) / 1024;
        el.innerHTML = kb.toFixed(1);
      }
    }
  },
  methods: {
    filesChange(e) {
      const fileList = e.target.files;
      if (!fileList.length) return;
      for (let i = 0; i < fileList.length; i += 1) {
        this.addFiles(fileList[i]);
      }
    },
    // upload data to the server
    saveFiles() {
      let uploaded = 0;
      for (let i = 0; i < this.files.length; i += 1) {
        const formData = new FormData();
        formData.append('file', this.files[i].file, this.files[i].filename);
        const thumbInfo = this.$refs.thumbInfo[i];
        const uploadItem = this.$refs.uploadItem[i];
        const uploadPercent = this.$refs.uploadPercent[i];
        const index = i;
        // thumbInfo.innerHTML = 'Uploading';

        const config = {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
            thumbInfo.innerHTML = `Uploaded ${percentCompleted}%`;
            this.files[i].uploaded = `${percentCompleted}%`;
            if (percentCompleted === 100) {
              thumbInfo.innerHTML = 'Image Prozessing';
            }
          }
        };
        const id = this.activeId;
        this.$store.dispatch('upload', { formData, id, config }).then((response) => {
          thumbInfo.innerHTML = 'Finished';
          uploadPercent.classList.add('--finished');
          uploaded++;
          if (this.files.length === uploaded) {
            setTimeout(() => {
              this.files = [];
            }, 1000);
          }
        });
      }
    },
    addFiles(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageDataURL = event.target.result;
        this.files.push({
          src: imageDataURL,
          filename: file.name,
          size: file.size,
          file,
          uploaded: 0
        });
      };
      reader.readAsDataURL(file);
    },
    resetFiles() {
      this.files = [];
    },
    remove(index) {
      this.files.splice(index, 1);
      // remove focus from field
      this.$refs.uploadItem[index].querySelector('.js-remove').blur();
    }
  },
  mounted() {
    this.resetFiles();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/album/uploader.vue